var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._l((_vm.recordList),function(item,index){return _c('record-cell',{key:index,attrs:{"item":item},on:{"clickItem":_vm.onClickItem}})}),(!_vm.loading && _vm.recordList.length === 0)?_c('van-empty',{attrs:{"description":"暂无记录"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }